import yellow from '@material-ui/core/colors/yellow';
import lightGreen from '@material-ui/core/colors/lightGreen';
import deepOrange from '@material-ui/core/colors/deepOrange';
import blue from '@material-ui/core/colors/blue';

const requestTypes = {
  brillaVisit: 1,
  couponDuplicate: 2,
  ownershipChange: 3,
  periodicRevision: 4,
  dischargeDeferred: 5,
  debtNegotiation: 6,
  changeConditions: 7,
  scheduledRevision: 8,
  partialPayment: 9,
  debtCertificate: 10,
  digitalInvoiceActivation: 11,
  digitalInvoiceDisable: 12,
  deferredPartialPayment: 13,
  subrogation: 14,
  brillaInsurance: 15,
  deferredWithCurrent: 16,
  constructorContact: 17,
  constructorQuotationRequest: 18,
  constructorAdditionalJobRequest: 19,
  constructorSubrogationRequest: 20,
  constructorAssociation: 21,
  industrialAssociation: 22,
  partialDeferredWithCurrent: 23,
  prepaidMeterRecharge: 24
};

const requestTitle = {
  [requestTypes.brillaVisit]: 'Visita Brilla',
  [requestTypes.couponDuplicate]: 'Duplicado',
  [requestTypes.ownershipChange]: 'Cambio de titular',
  [requestTypes.dischargeDeferred]: 'Pago de diferido',
  [requestTypes.periodicRevision]: 'Revisión periódica',
  [requestTypes.debtNegotiation]: 'Negociación de deuda',
  [requestTypes.changeConditions]: 'Cambio de condiciones',
  [requestTypes.scheduledRevision]: 'Agendamiento de revisión',
  [requestTypes.partialPayment]: 'Abono a deuda',
  [requestTypes.debtCertificate]: 'Certificado de deuda',
  [requestTypes.digitalInvoiceActivation]: 'Activación factura digital',
  [requestTypes.digitalInvoiceDisable]: 'Desactivación factura digital',
  [requestTypes.deferredPartialPayment]: 'Abono a financiación Brilla',
  [requestTypes.subrogation]: 'Subrogación',
  [requestTypes.brillaInsurance]: 'Adquisición de seguro',
  [requestTypes.deferredWithCurrent]: 'Pago de diferido más corriente',
  [requestTypes.constructorContact]: 'Solicitud de contacto',
  [requestTypes.constructorQuotationRequest]: 'Solicitud de cotización',
  [requestTypes.constructorAdditionalJobRequest]: 'Solicitud adicional de obra',
  [requestTypes.constructorSubrogationRequest]: 'Subrogación de contratos',
  [requestTypes.constructorAssociation]: 'Asociación contrato constructora',
  [requestTypes.industrialAssociation]: 'Asociación contrato industrial',
  [requestTypes.partialDeferredWithCurrent]: 'Abono a diferido más corriente',
  [requestTypes.prepaidMeterRecharge]: 'Recarga de Medidor Prepago'
};

//TO-DO: Remove use of renderType
const renderType = type => {
  return requestTitle[type];
};

const requestStatus = {
  registered: 1,
  inProcess: 2,
  attended: 3,
  cancelled: 4
};

const renderStatus = status => {
  switch (status) {
    case requestStatus.inProcess:
      return { statusText: 'En proceso', statusColor: yellow.A700 };
    case requestStatus.registered:
      return { statusText: 'Registrada', statusColor: lightGreen.A400 };
    case requestStatus.cancelled:
      return { statusText: 'Rechazada', statusColor: deepOrange[300] };
    case requestStatus.attended:
      return { statusText: 'Atendida', statusColor: blue[800] };
    default:
      return {};
  }
};

const ContractAssociationRequestTypes = [
  requestTypes.constructorAssociation,
  requestTypes.industrialAssociation
];

export {
  requestTypes,
  requestStatus,
  renderType,
  renderStatus,
  ContractAssociationRequestTypes
};
